import { NudosGenericModal, NudosModalContent } from 'components/NudosComponents';
import QuoteConfirmationModalContent from './QuoteConfirmationModalContent';
import './QuoteConfirmationModalContent.scss';

interface IQuoteConfirmationModal {
  quoteId: number;
  clientName: string;
  countryName: string;
  countryCode: string;
  quotedToolsCount: number;
  totalAmount: string;
  organizationId?: number;
  onClose: () => void;
  onConfirm: (expirationDate: string) => void;
}

/**
 * Modal de confirmación para enviar la cotización al cliente.
 * Envuelve el overlay genérico y delega el contenido a QuoteConfirmationModalContent.
 */
const QuoteConfirmationModal = (props: IQuoteConfirmationModal) => {
  return (
    <NudosGenericModal
      closeModalCallback={props.onClose}
      clickOutsideCallback={props.onClose}
      customClassName="quoteConfirmationModal"
      modalContent={
        <NudosModalContent
          customWidth="48rem"
          customHeight="52rem"
          excludeHeader
          isSectionContainerFull
          CustomModalComponent={<QuoteConfirmationModalContent {...props} />}
        />
      }
    />
  );
};

export default QuoteConfirmationModal;
